/* tslint:disable */

declare var Object: any;
export interface JobInterface {
  "id"?: string;
  "created"?: Date;
  "pagePostedFromValue"?: string;
  "analyticsClientId"?: string;
  "taskId": string;
  "verticalType": number;
  "specificQuestions"?: any;
  "jobDescription"?: string;
  "street"?: string;
  "apartmentNumber"?: number;
  "zipcode"?: string;
  "firstName"?: string;
  "lastName"?: string;
  "email"?: string;
  "phoneNumber"?: string;
  "tcpaConsent"?: boolean;
  "tcpaCopy"?: string;
  "clientIpAddr"?: string;
  "userAgent"?: string;
}

export class Job implements JobInterface {
  "id": string;
  "created": Date;
  "pagePostedFromValue": string;
  "analyticsClientId": string;
  "taskId": string;
  "verticalType": number;
  "specificQuestions": any;
  "jobDescription": string;
  "street": string;
  "apartmentNumber": number;
  "zipcode": string;
  "firstName": string;
  "lastName": string;
  "email": string;
  "phoneNumber": string;
  "tcpaConsent": boolean;
  "tcpaCopy": string;
  "clientIpAddr": string;
  "userAgent": string;
  constructor(data?: JobInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Job`.
   */
  public static getModelName() {
    return "Job";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Job for dynamic purposes.
  **/
  public static factory(data: JobInterface): Job{
    return new Job(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Job',
      plural: 'jobs',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "created": {
          name: 'created',
          type: 'Date'
        },
        "pagePostedFromValue": {
          name: 'pagePostedFromValue',
          type: 'string'
        },
        "analyticsClientId": {
          name: 'analyticsClientId',
          type: 'string'
        },
        "taskId": {
          name: 'taskId',
          type: 'string'
        },
        "verticalType": {
          name: 'verticalType',
          type: 'number'
        },
        "specificQuestions": {
          name: 'specificQuestions',
          type: 'any'
        },
        "jobDescription": {
          name: 'jobDescription',
          type: 'string'
        },
        "street": {
          name: 'street',
          type: 'string'
        },
        "apartmentNumber": {
          name: 'apartmentNumber',
          type: 'number'
        },
        "zipcode": {
          name: 'zipcode',
          type: 'string'
        },
        "firstName": {
          name: 'firstName',
          type: 'string'
        },
        "lastName": {
          name: 'lastName',
          type: 'string'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "phoneNumber": {
          name: 'phoneNumber',
          type: 'string'
        },
        "tcpaConsent": {
          name: 'tcpaConsent',
          type: 'boolean'
        },
        "tcpaCopy": {
          name: 'tcpaCopy',
          type: 'string'
        },
        "clientIpAddr": {
          name: 'clientIpAddr',
          type: 'string'
        },
        "userAgent": {
          name: 'userAgent',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Job.ts